import {assertNotNull} from "./CommonUtils.js";

export default class HttpClient {
    #baseUrl;
    #basicAuthUsername;
    #basicAuthPassword;

    /**
     * @param {string} baseUrl
     * @param {string|null} basicAuthUsername if nothing is passed, it just reuses current session. It's useful
     *                                        only for tests at the moment.
     * @param {string|null} basicAuthPassword
     */
    constructor(baseUrl, basicAuthUsername = null, basicAuthPassword = null) {
        console.debug(`Current Base URL for BE access: [${baseUrl}]`);
        this.#baseUrl = assertNotNull(baseUrl);
        this.#basicAuthUsername = basicAuthUsername;
        this.#basicAuthPassword = basicAuthPassword;
    }

    async fetch(url, data = {}) {
        data.headers = data.headers || {};
        Object.assign(data.headers, this.#authHeader());
        const response = await fetch(this.#baseUrl + url, data);
        if(response.status >= 300)
            throw new Error(`Response ${response.status}: ${response.statusText}`)
        return response;
    }

    #authHeader() {
        if(!this.#basicAuthUsername)
            return {};
        const creds = Buffer.from((this.#basicAuthUsername + ":" + this.#basicAuthPassword)).toString('base64');
        return {Authorization: 'Basic ' + creds};
    }
}